import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=94fd0308&"
import script from "./Sticky.vue?vue&type=script&lang=ts&"
export * from "./Sticky.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports